import * as clipboard from 'clipboard-polyfill/text';

export default function copyToClipboard(str) {
  clipboard.writeText(str);
}
